// extracted by mini-css-extract-plugin
module.exports = {"component":"FixieInfo_component__simMU","blue":"FixieInfo_blue__BUgZQ","grey":"FixieInfo_grey__GTR1o"};